module.exports = __webpack_public_path__ + "static/media/18ECA30.e6487033.jpg";